import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import Amount from "@/models/Shared/Amount";

export default class InstitutionAccountSettings extends BaseInstitutionEntity {
    currency: string = '';
    transactionLimit: Amount = new Amount();
    dailyLimit: Amount = new Amount();
    oneApprovalThreshold: Amount;
    oneApprovalThresholdActive: boolean = false;
    twoApprovalThreshold: Amount;
    twoApprovalThresholdActive: boolean = false;
    threeApprovalThreshold: Amount;
    threeApprovalThresholdActive: boolean = false;
}